import { lazy } from "react";

export default lazy(() =>
  import("./TestMyFeatureRoutes").then((module) => ({
    default: module.TestMyFeatureRoutes,
  }))
);
